<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="pd-proct-parentdiv">
			<div class="headtext d-flex align-items-center">
				<div class="heading mt-3">
					<span>Proctoring Dashboard</span>
				</div>
			</div>

			<div class="d-flex align-items-center">
				<div class="proct-left-container mt-3">
					<div class="proct-summary-card">
						<div class="d-flex justify-content-between">
							<div class="summary-txt">Summary</div>
							<div class="proc-tctg d-flex align-items-center">
								<div>
									<span class="proctgtc-txt">Total Groups</span
									><span class="proct-tctg-count ml-2">
										{{ TotalCandidatesData }}
										<!-- 88 -->
									</span>
								</div>
								<div class="ml-4">
									<span class="proctgtc-txt">Total Candidates</span
									><span class="proct-tctg-count ml-2">
										{{ TotalCandidatesGroupData }}
										<!-- 89 -->
									</span>
								</div>
							</div>
						</div>
						<div class="pr-sumry-subtxt">
							Currently showing the 100 most recent groups created
						</div>
						<div class="d-flex align-items-center mt-3">
							<div
								@click="getGraph('TOPIC')"
								:class="
									highlightActiveTab == 'TOPIC'
										? 'proc-ctt-tabs-active'
										: 'proc-ctt-tabs-inactive'
								"
								class="pointer"
							>
								Topic
							</div>
							<div
								:class="
									highlightActiveTab === 'TEST'
										? 'proc-ctt-tabs-active'
										: 'proc-ctt-tabs-inactive'
								"
								class="pointer"
								@click="getGraph('TEST')"
							>
								Test
							</div>
							<div
								:class="
									highlightActiveTab === 'CAN'
										? 'proc-ctt-tabs-active'
										: 'proc-ctt-tabs-inactive'
								"
								class="pointer"
								@click="getGraph('CAN')"
							>
								Candidates
							</div>
						</div>
						<div id="proctBarGraph" class="barChart"></div>
					</div>

					<div class="proct-evaluated-card mt-3">
						<div class="d-flex justify-content-between">
							<div class="summary-txt">Total Evaluated</div>
							<div class="d-flex align-item">
								<div class="d-flex">
									<div
										class="w-120 pointer"
										@click="getDataForLineGraphMain('daily')"
										:class="
											highlightActiveTabForLineGraph === 'daily'
												? 'proc-ctt-tabs-active'
												: 'proc-ctt-tabs-inactive'
										"
									>
										This Week
									</div>
									<div
										class="w-120 pointer"
										@click="getDataForLineGraphMain('weekly')"
										:class="
											highlightActiveTabForLineGraph === 'weekly'
												? 'proc-ctt-tabs-active'
												: 'proc-ctt-tabs-inactive'
										"
									>
										This Month
									</div>
									<div
										class="w-120 pointer"
										@click="getDataForLineGraphMain('monthly')"
										:class="
											highlightActiveTabForLineGraph === 'monthly'
												? 'proc-ctt-tabs-active'
												: 'proc-ctt-tabs-inactive'
										"
									>
										Last 7 Months
									</div>
								</div>
								<div
									v-if="roles.includes('GET_REPORTS')"
									class="ml-3 reportbtn pointer"
									v-on:click="gotoReports()"
								>
									<span class="mr-3">
										<img
											src="../../assets/icons/proctoring/gotoreport.svg"
											alt=""
									/></span>
									Reports
								</div>
							</div>
						</div>
						<div id="proctLineChart" class="lineChart"></div>
					</div>
				</div>
				<div class="proct-right-container mt-3 position-relative ml-3">
					<div class="d-flex">
						<div
							class="w-120 pointer"
							@click="handleTabClick(true, 'G', 'Groups')"
							:class="
								groupview ? 'proc-ctt-tabs-active' : 'proc-ctt-tabs-inactive'
							"
						>
							Groups
						</div>
						<div
							class="w-120 pointer"
							@click="handleTabClick(false, 'I', 'Individual')"
							:class="
								!groupview ? 'proc-ctt-tabs-active' : 'proc-ctt-tabs-inactive'
							"
						>
							Individual
						</div>
					</div>

					<div
						class="d-flex align-items-center justify-content-between mt-3 position-relative"
					>
						<div class="relativeclass mr-2" style="width: 85%">
							<div class="new-recsearchicon-pos pr-3">
								<img src="../../assets/searchicon.svg" alt="" />
							</div>
							<b-form-input
								:placeholder="`Search ${placeholderValue}`"
								v-model="groupname"
								@keyup="searchGroupname()"
								class="pl-4 pr-4 search-ques"
							></b-form-input>
							<div class="searchicon">
								<img
									class="pointer"
									v-if="groupname.length != 0"
									src="../../assets/icons/Qpbuilder/cross.svg"
									alt=""
									@click="clearSearch()"
								/>
							</div>
						</div>
						<div class="d-flex align-items-end justify-content-end">
							<div class="reportbtn pointer" @click="filter()" ref="filterbox">
								<div>Filter</div>

								<div class="ml-2 d-flex relativeclass">
									<span><img src="../../assets/filtericon.svg" alt="" /> </span>
								</div>
								<div
									class="proct-filter-count mb-3"
									v-if="storeSelectedTest.length != 0"
								>
									{{ storeSelectedTest.length }}
								</div>
							</div>
						</div>
						<div
							v-if="filterview"
							class="cj-filter-modal"
							ref="filterdropdown"
							v-closable="{
								exclude: ['filterbox', 'filterdropdown'],
								handler: 'closeFilter',
							}"
						>
							<div @click="closeFilter()" class="xMarkCancel">
								<img src="../../assets/xmark.svg" alt="" />
							</div>
							<b-overlay :show="showLoaderfilter" rounded="sm">
								<div v-if="showtest">
									<div class="d-flex align-items-start">
										<div class="pointer" @click="closeTest()">
											<img
												src="../../assets/icons/Reports/bckarrow.svg"
												alt=""
											/>
										</div>
										<div class="ml-2 jd-testhead text-truncate">
											<span
												class="text-truncate folder-bar-head d-inline-block"
												v-b-tooltip.hover.top="{ variant: 'secondary' }"
												:title="selTopicName"
												style="max-width: 100%"
												>Tests <strong> ({{ selTopicName }})</strong></span
											>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="jd-testhead">
										<span class="folder-bar-head">Topics</span>
									</div>
								</div>
								<div class="position-relative recinput mt-2">
									<div class="new-recsearchicon-pos">
										<img src="../../assets/searchicon.svg" alt="" />
									</div>
									<b-form-input
										class="inputField"
										type="text"
										:placeholder="
											`${showtest == true ? 'Search Tests' : ' Search Topics'}`
										"
										v-model="searchFilter"
										debounce="500"
										@update="searchFilterM()"
									>
									</b-form-input>
									<div class="searchicon">
										<img
											class="pointer"
											v-show="searchFilter.length"
											src="../../assets/icons/Qpbuilder/cross.svg"
											@click="(searchFilter = ''), searchFilterM()"
											alt=""
										/>
									</div>
								</div>
								<div class="pd-filtercontent-modal" @scroll="scroll">
									<template
										v-if="showtest == false && filterTopic.length !== 0"
									>
										<div
											v-for="(i, index) in filterTopic"
											:key="index"
											class="pd-checkboxes-background pointer m-1"
										>
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<b-form-checkbox
													:id="i.topicID"
													:value="i.topicID"
													size="sm"
													@change="selectTopicIDS(i.topicID, i.testIDs, index)"
													name="flavour-4a"
													v-model="selectedTopic"
												>
													<div class="text-truncate" style="color: #6d6d6d">
														{{ i.name }}
													</div>
												</b-form-checkbox>

												<div
													@click="
														(selectedTopicIndex = index),
															(page = 0),
															closeTopic(i),
															copy(),
															getProctoringFilterData('TEST', storeTopicId)
													"
												>
													<img
														src="../../assets/icons/proctoring/rightarrow.svg"
														alt=""
													/>
												</div>
											</div>
										</div>
										<div
											v-if="this.filterPageEnd != this.totalFilterData"
											style="margin: auto"
											class="d-flex justify-content-center mb-3"
										>
											<b-spinner small label="Loading..."></b-spinner>
										</div>
									</template>

									<template v-if="showtest && filterTest.length != 0">
										<div
											class="pd-checkboxes-background pointer m-1"
											v-for="(i, index) in filterTest"
											:key="index"
										>
											<b-form-checkbox
												size="sm"
												name="flavour-4a"
												:value="i.testID"
												v-model="selectedTest"
												@change="selectTestIDs(i.topicID)"
											>
												<div class="text-truncate" style="color: #6d6d6d">
													{{ i.name }}
												</div>
											</b-form-checkbox>
										</div>
									</template>
									<template
										v-if="
											filterTopic.length === 0 &&
												filterTest.length === 0 &&
												searchFilter == ''
										"
									>
										<span
											class="archivebox-heading mt-2 d-flex justify-content-center wordbreak"
										>
											Currently no topics added "
										</span>
									</template>
									<template
										v-else-if="
											filterTopic.length === 0 &&
												filterTest.length === 0 &&
												searchFilter != ''
										"
									>
										<span
											class="archivebox-heading mt-2 d-flex justify-content-center wordbreak"
										>
											No matching results for "{{ searchFilter }}"
										</span>
									</template>
								</div>
								<div
									class="d-flex justify-content-between align-items-center mt-3"
								>
									<div
										class="pd-clearfilter pointer mt-3"
										:class="
											selectedTest == '' &&
											selectedTopic == '' &&
											searchFilter == ''
												? storeSelectedTest.length == 0
													? 'disabled-text'
													: 'pointer'
												: 'pointer'
										"
										@click="
											selectedTest == '' &&
											selectedTopic == '' &&
											searchFilter == ''
												? storeSelectedTest.length == 0
													? ''
													: clearfilter()
												: clearfilter()
										"
									>
										Clear Filter
									</div>
									<div>
										<b-button
											class="addbtn pl-3 pr-3"
											:disabled="selectedTest == '' && selectedTopic == ''"
											@click="
												(filterview = false),
													(applyfilter = true),
													getProctorGroupList()
											"
										>
											Apply
										</b-button>
									</div>
								</div>
							</b-overlay>
						</div>
					</div>

					<b-overlay :show="showLoader" rounded="sm">
						<div
							class="proct-gi-container position-relative mt-3"
							v-if="selectedType == 'G' && total > 0"
						>
							<div
								class="proct-gicards d-flex align-items-center m-3 pointer"
								v-for="(grplist, index) in getProctorDetails"
								:key="index"
								@click="gotoproctortest(grplist)"
							>
								<div class="proctdash-gicards-gridcolorbar"></div>
								<div class="proct-grpname" style="width: 60%">
									<div class="text-truncate">{{ grplist.groupName }}</div>
								</div>
								<div class="d-flex align-items-center" style="width: 20%">
									<div class="proct-gt-tctxt">Test</div>
									<div class="proct-gt-tccounttxt ml-2">
										{{ grplist.testCount }}
									</div>
								</div>
								<div class="d-flex align-items-center" style="width: 20%">
									<div class="proct-gt-tctxt">Candidates</div>
									<div class="proct-gt-candcounttxt ml-2">
										{{ grplist.candidateCount }}
									</div>
								</div>
							</div>
						</div>
						<div
							v-else-if="selectedType == 'G' && total == 0"
							class="proct-gi-container position-relative mt-3 d-flex flex-column align-items-center justify-content-center"
						>
							<div
								v-if="
									selectedTopic == '' && selectedTest == '' && groupname == ''
								"
							>
								<img src="../../assets/icons/proctoring/noGroup.svg" alt="" />
							</div>
							<div v-else>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div>
								<span
									v-if="selectedTopic != '' || selectedTest != ''"
									class="searchnotfound wordbreak"
									>No matching results for selected filters.</span
								>
								<span
									v-else-if="
										selectedTopic == '' && selectedTest == '' && groupname != ''
									"
									class="searchnotfound wordbreak"
									>No matching results for
									<span class="searchtext"> "{{ groupname }}" </span>
									.</span
								>
								<span
									v-else-if="
										selectedTopic == '' && selectedTest == '' && groupname == ''
									"
									class="searchnotfound wordbreak"
								>
									No groups have been created.
								</span>
							</div>
						</div>
						<div
							class="proct-gi-container position-relative mt-3"
							v-else-if="selectedType == 'I' && total > 0"
						>
							<div
								class="proct-gicards d-flex align-items-center m-3 pointer"
								v-for="(grplist, index) in getProctorDetails"
								:key="index"
								@click="gotoproctortest(grplist)"
							>
								<div class="proctdash-gicards-Igridcolorbar"></div>
								<div class="proct-grpname" style="width: 90%">
									<div class="text-truncate">{{ grplist.groupName }}</div>
								</div>
								<div class="d-flex align-items-center" style="width: 10%">
									<div class="proct-gt-tctxt">Test</div>
									<div class="proct-gt-tccounttxt ml-2">
										{{ grplist.testCount }}
									</div>
								</div>
							</div>
						</div>
						<div
							v-else-if="selectedType == 'I' && total == 0"
							class="proct-gi-container position-relative mt-3 d-flex flex-column align-items-center justify-content-center"
						>
							<div
								v-if="
									selectedTopic == '' && selectedTest == '' && groupname == ''
								"
							>
								<img
									src="../../assets/icons/proctoring/noIndividual.svg"
									alt=""
								/>
							</div>
							<div v-else>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div>
								<span
									v-if="selectedTopic != '' || selectedTest != ''"
									class="searchnotfound wordbreak"
									>No matching results for selected filters.</span
								>
								<span
									v-else-if="
										selectedTopic == '' && selectedTest == '' && groupname != ''
									"
									class="searchnotfound wordbreak"
									>No matching results for
									<span class="searchtext"> "{{ groupname }}" </span>
									.</span
								>
								<span
									v-else-if="
										selectedTopic == '' && selectedTest == '' && groupname == ''
									"
									class="searchnotfound wordbreak"
								>
									No individuals have been created.
								</span>
							</div>
						</div>
					</b-overlay>
					<div
						class="proct-paginaTion d-flex justify-content-between align-items-center"
					>
						<div class="pagination">
							<b-pagination
								v-model.number="currentPage"
								@input="goToPageNum()"
								:total-rows="total"
								:per-page="groupCount"
								align="center"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div class="qb-gotopage-text mr-2">
							Results : <span v-if="pageStart > total">0</span
							><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
							<span class="pl-1"></span> of <span class="pr-1"></span
							>{{ total }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	getProctorGroups,
	postEvalTestGroups,
	getProcteringFilter,
	getProctorGroupsForLineGraph,
} from "../../utils/apiFunctions";
import errorToast from "../../views/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { mapGetters } from "vuex";
import * as d3 from "d3";
import { proctBarChart, proctLineChart } from "vue-d3-charts-hire3x";
export default {
	name: "ProctoringDashboard",
	components: {
		Spinner,
		// ProctoringBarChartVue,
		// ProctoringLineChartVue
	},
	data() {
		return {
			evaluatorTestOnly: Boolean,
			filterview: false,
			applyfilter: false,
			filterTopic: [],
			filterTest: [],
			storeTopic: [],
			groupview: true,
			groupCount: "50",
			selTopicName: "",
			groupname: "",
			showLoader: true,
			showLoaderfilter: true,
			placeholderValue: "Groups",
			page: 0,
			showtest: false,
			LoaderStatus: false,
			currentPage: 1,
			total: null,
			pageStart: "",
			topicCheck: false,
			pageEnd: "",
			getProctorDetails: [],
			highlightActiveTab: "TOPIC",
			barGraphCreated: false,
			highlightActiveTabForLineGraph: "daily",
			lineGraphCreated: false,
			selectedTestArray: [],
			selectedTest: [],
			selectedTopic: [],
			storeSelectedTest: [],
			storeSelectedTopic: [],
			selectedTopicIndex: null,
			storeTopicId: "",
			checked: true,
			searchFilter: "",
			selectedType: "G",
			filterPageEnd: null,
			totalFilterData: null,
			TotalCandidatesGroupData: 0,
			TotalCandidatesData: 0,
		};
	},

	beforeDestroy() {
		d3.selectAll(".toolTipForBarGraph").remove();
	},
	created() {
		this.LoaderStatus = true;

		
		if(this.proctoringFilter.applyfilter){
		
			this.applyfilter = this.proctoringFilter.applyfilter;
		this.selectedTest = this.proctoringFilter.selectedTest;
		this.selectedTopic = this.proctoringFilter.selectedTopic;
		this.searchFilter = this.proctoringFilter.searchFilter;
		}

		this.tabRedirect();
	},
	mixins: [errorToast],
	async mounted() {
		this.procBarChart();
		this.procLineChart();
	},
	computed: {
		...mapGetters(["roles"]),
		...mapGetters("testVUEX",{
			proctoringFilter : "getProctoringFilter"
		})
	},
	watch: {
		selectedTestArray(newValue) {
			if (newValue.length === 0) {
				this.topicCheck = false;
			} else if (newValue.length === this.filterData.testIDs.length) {
				this.topicCheck = true;
			} else {
				this.topicCheck = false;
			}
		},
		highlightActiveTab() {
			this.$router.push({
				query: {
					summary: this.highlightActiveTab.toLowerCase(),
					evaluated: this.highlightActiveTabForLineGraph,
					groups: this.groupview,
				},
			});
		},
		highlightActiveTabForLineGraph() {
			this.$router.push({
				query: {
					summary: this.highlightActiveTab.toLowerCase(),
					evaluated: this.highlightActiveTabForLineGraph,
					groups: this.groupview,
				},
			});
		},
		groupview() {
			this.$router.push({
				query: {
					summary: this.highlightActiveTab.toLowerCase(),
					evaluated: this.highlightActiveTabForLineGraph,
					groups: this.groupview,
				},
			});
		},
	},

	methods: {
		// Function to manage tab redirect
		tabRedirect() {
			if (
				this.$route.query.summary ||
				this.$route.query.evaluated ||
				this.$route.query.groups
			) {
				this.highlightActiveTab = this.$route.query.summary.toUpperCase();
				console.log(this.highlightActiveTab);
				this.getGraph(this.highlightActiveTab);
				this.highlightActiveTabForLineGraph = this.$route.query.evaluated;
				this.getDataForLineGraphMain(this.highlightActiveTabForLineGraph);
				const storedValue = this.$route.query.groups;
				if (storedValue !== undefined) {
					this.groups = storedValue === "true"; // Convert the stored value to a boolean
				}
				// Render appropriate tab on screen
				if (this.groups) {
					this.handleTabClick(true, "G", "Groups");
				} else {
					this.handleTabClick(false, "I", "Individual");
				}
			} else {
				// Call a function to set the `selectedType` and `groupview` properties of the component
				// based on the current route.
				const { selectedType, groupview } = this.setTabValuesFromRoute(
					this.$route
				);

				// Set the `selectedType` property of the component to the value returned by the `setTabValuesFromRoute`
				this.selectedType = selectedType;

				// Set the `groupview` property of the component to the value returned by the `setTabValuesFromRoute`
				this.groupview = groupview;
				this.getProctorGroupList();
				this.getProctoringFilterData("TOPIC");
			}
		},
		gotoReports() {
			this.$router.push({
				path: "/reports",
				query: { redirect: "ProctoringDashboard" },
			});
		},
		hidefilterbox() {
			this.filterview = false;
		},
		handleChildDataTotalGroups(data) {
			this.TotalCandidatesGroupData = data;
		},
		// handleChildDatacandidatesTotal(data) {
		//   this.TotalCandidatesData = data;
		// },
		async getDataForLineGraphMain(dataType) {
			this.highlightActiveTabForLineGraph = dataType;
			this.procLineChart();
		},
		async getGraph(type) {
			this.highlightActiveTab = type;
			this.procBarChart();
		},
		searchFilterM() {
			this.showLoaderfilter = true;
			this.page = 0;
			this.getProctoringFilterData(!this.showtest ? "TOPIC" : "TEST");
		},
		gotoproctortest(data) {
			if (this.roles.includes("GET_PROCTORING_TEST")) {
				// Save current filter state in Vuex before leaving the page
				this.$store.commit("testVUEX/saveProctoringFilters", {
					applyfilter: this.applyfilter,
					selectedTest: this.selectedTest, // matches Vuex key
					selectedTopic: this.selectedTopic,
					searchFilter: this.searchFilter,
				});

				// Navigate to proctortest page
				this.$router.push({
					path: `proctortest/${data.groupID}/${data.candidateType}`,
					query: {
						name: data.groupName,
						summary: this.highlightActiveTab.toLowerCase(),
						evaluated: this.highlightActiveTabForLineGraph,
						groups: this.groupview,
					},
				});
			} else {
				this.errorToast("You don't have access to this page!");
			}
		},

		clearfilter() {
			this.searchFilter = "";
			this.page = 0;
			this.selectedTopic = [];
			this.selectedTest = [];
			this.showLoaderfilter = true;
			this.getProctoringFilterData(!this.showtest ? "TOPIC" : "TEST");
			if (this.storeSelectedTest.length != 0) {
				this.storeSelectedTest = [];
				this.storeSelectedTopic = [];
				this.getProctoringFilterData(!this.showtest ? "TOPIC" : "TEST");
				this.getProctorGroupList();
				this.applyfilter = false;
				this.filterview = false;
			}
		},
		closeFilter() {
			this.searchFilter = "";
			this.storeTopicId = "";
			this.filterTopic = [];
			this.filterTest = [];
			this.filterview = false;
			if (!this.applyfilter) {
				//   this.getProctorGroupList()
				// } else {
				this.selectedTopic = [];
				this.selectedTest = [];
			}
		},
		async getProctorGroupList() {
			this.showLoader = true;
			try {
				const payload = {
					page: (this.currentPage - 1).toString(),
					count: this.groupCount,
					type: this.selectedType,
					searchQuery: this.groupname,
					testIDs: this.applyfilter ? this.selectedTest : [], // only send if filter is applied
				};
				console.log("testIDs", this.selectedTest);
				this.storeSelectedTest = [...this.selectedTest];
				this.storeSelectedTopic = [...this.selectedTopic];

				let res;
				if (
					this.roles.includes("GET_EVALUATOR_TEST") &&
					!this.roles.includes("GET_PROCTORING")
				) {
					this.evaluatorTestOnly = true;
					res = await postEvalTestGroups(payload);
				} else {
					this.evaluatorTestOnly = false;

					res = await getProctorGroups(payload);
				}

				if (res.status == 200) {
					this.LoaderStatus = false;
					this.showLoader = false;
					this.getProctorDetails = res.data.data.data;
					this.pageStart = res.data.data.pageStart;
					this.pageEnd = res.data.data.pageEnd;
					this.total = res.data.data.total;
				}
			} catch (error) {
				this.LoaderStatus = false;
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		searchGroupname() {
			if (this.groupview) {
				this.selectedType = "G";
				this.getProctorGroupList();
			} else {
				this.selectedType = "I";
				this.getProctorGroupList();
			}
		},
		clearSearch() {
			this.groupname = "";
			if (this.groupview) {
				this.selectedType = "G";
				this.getProctorGroupList();
			} else {
				this.selectedType = "I";
				this.getProctorGroupList();
			}
		},
		async filter() {
			this.page = 0;
			this.filterview = !this.filterview;
			this.showLoaderfilter = true;
			this.selectedTest = [...this.storeSelectedTest];
			this.selectedTopic = [...this.storeSelectedTopic];
			await this.getProctoringFilterData("TOPIC");
			this.showtest = false;
			this.searchFilter = "";
			this.storeTopicId = "";
			if (!this.applyfilter) {
				this.selectedTopic = [];
				this.selectedTest = [];
			}
		},
		hideFilterFunction() {
			this.filterview = false;
		},
		async closeTest() {
			this.showLoaderfilter = true;
			this.page = 0;
			this.searchFilter = "";
			this.storeTopicId = "";
			await this.getProctoringFilterData("TOPIC");
			this.showtest = false;
		},
		closeTopic(data) {
			this.searchFilter = "";
			this.selTopicName = data.name;
			this.storeTopicId = data.topicID;
		},
		copy() {
			this.storeTopic = this.filterTopic.slice();
			this.showLoaderfilter = true;
		},
		selectTopicIDS(topicID, testIDs, index) {
			this.selectedTopicIndex = index;
			if (this.selectedTopic.includes(topicID)) {
				for (let i in testIDs) {
					this.selectedTest.push(testIDs[i]);
				}
			} else {
				for (let j in testIDs) {
					this.selectedTest = this.selectedTest.filter((id) => {
						return id != testIDs[j];
					});
				}
			}
		},
		selectTestIDs(topicID) {
			const hasAllElems = this.storeTopic[
				this.selectedTopicIndex
			].testIDs.every((elem) => this.selectedTest.includes(elem));

			if (hasAllElems && !this.selectedTopic.includes(topicID)) {
				this.selectedTopic.push(topicID);
			} else if (!hasAllElems && this.selectedTopic.includes(topicID)) {
				this.selectedTopic = this.selectedTopic.filter((id) => id !== topicID);
			}
			// If topicID is already in selectedTopic and hasAllElems is true, we don't need to do anything.
		},
		onclear() {
			if (this.selectedTest.length == 0) {
				if (this.groupview) {
					this.selectedType = "G";
					this.getProctorGroupList();
				} else {
					this.selectedType = "I";
					this.getProctorGroupList();
				}
				this.applyfilter = false;
			}
		},
		async procBarChart() {
			let res2;

			try {
				let payload = {
					count: "100",
					page: "0",
					type: "G",
					order: "1",
				};

				if (this.evaluatorTestOnly) {
					res2 = await postEvalTestGroups(payload);
				} else {
					res2 = await getProctorGroups(payload);
				}
				if (res2.status == 200) {
					let allBarData2;
					let max2;
					let full_data2 = res2.data.data.data;
					this.TotalCandidatesData = res2.data.data.total;
					this.TotalCandidatesGroupData =
						res2.data.data.totalCandidatesTakenTest;
					if (this.highlightActiveTab === "TOPIC") {
						allBarData2 = res2.data.data.topicCount;
						max2 = Math.max(...full_data2.map((o) => o.topicCount));
					} else if (this.highlightActiveTab === "TEST") {
						allBarData2 = res2.data.data.testCount;
						max2 = Math.max(...full_data2.map((o) => o.testCount));
					} else if (this.highlightActiveTab === "CAN") {
						allBarData2 = res2.data.data.candCount;
						max2 = Math.max(...full_data2.map((o) => o.candidateCount));
					}

					const barColor = "#3379B3";
					let tempArr = [];
					for (let i = 0; i < 20; i++) {
						tempArr.push(" ");
					}
					let xScaleDomainGridLines = tempArr.map((d) => d);
					let xScaleDomain2 = full_data2.map((d) => d.groupName);
					if (document.getElementById("proctBarGraph").innerHTML !== null) {
						document.getElementById("proctBarGraph").innerHTML = "";
					}

					let chart2 = new proctBarChart();
					chart2.proctBarData(
						"#proctBarGraph",
						this.highlightActiveTab,
						full_data2,
						max2,
						allBarData2,
						xScaleDomain2,
						xScaleDomainGridLines, //Different Logic for gridlines
						barColor
					);
				}
			} catch (error) {
				console.log("one more error api");
			}
		},

		async procLineChart() {
			try {
				const response = await getProctorGroupsForLineGraph(
					this.highlightActiveTabForLineGraph
				);
				if (response.status == 200) {
					let lineData = response.data.data;

					if (document.getElementById("proctLineChart").innerHTML !== null) {
						document.getElementById("proctLineChart").innerHTML = "";
					}

					let linechart = new proctLineChart();
					linechart.makeProcLineChart("#proctLineChart", lineData);
				}
			} catch (error) {
				console.log("one more error api");
			}
		},
		/**
		 * Handles a scroll event and loads more proctoring filter data when the user reaches the
		 * bottom of the scrollable area.
		 *
		 * @param {Event} e - The scroll event.
		 */
		scroll(e) {
			// Get the target element of the scroll event.
			const { target } = e;

			// Check if the user has reached the bottom of the scrollable area.
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				// Check if there is more filter data to load.

				if (this.checkbetween(this.filterPageEnd, 0, this.totalFilterData)) {
					// Increment the page number if the search filter is empty.
					// if (this.searchFilter == "") {
					this.page++;
					// }

					// Load more proctoring filter data.
					const filterType = !this.showtest ? "TOPIC" : "TEST";
					this.getProctoringFilterData(filterType);
				}
			}
		},

		/**
		 * Returns a boolean value indicating whether a given number `x` is between the given
		 * minimum and maximum values.
		 *
		 * @param {Number} x - The number to check.
		 * @param {Number} min - The minimum value.
		 * @param {Number} max - The maximum value.
		 * @returns {Boolean} - `true` if `x` is between `min` and `max`, otherwise `false`.
		 */
		checkbetween(x, min, max) {
			// Return `true` if `x` is between `min` and `max`, otherwise `false`.
			return x > min && x < max;
		},

		/**
		 * Handles the click event of a tab and updates the `selectedType`, `placeholderValue`,
		 * `groupview`, and `currentPage` data properties. Invokes the `getProctorGroupList` method
		 * to update the proctor group list.
		 *
		 * @param {Boolean} groupview - Whether to show the proctor group view.
		 * @param {String} selectedType - The selected proctor type.
		 * @param {String} placeholderValue - The placeholder value for the proctor type dropdown.
		 */
		handleTabClick(groupview, selectedType, placeholderValue) {
			// Update the selected proctor type and placeholder value.
			this.selectedType = selectedType;
			this.placeholderValue = placeholderValue;

			// Update the proctor group list.
			this.getProctorGroupList();

			// Update the proctor group view visibility and current page.
			this.groupview = groupview;
			this.currentPage = 1;
		},

		/**
		 * Called when pagnation is Invoked
		 * Updates the `selectedType` data property based on the `groupview` data property value,
		 * then invokes the `getProctorGroupList` method to update the proctor group list.
		 */
		goToPageNum() {
			// Set the selected proctor type based on the group view visibility.
			// If the group view is visible, select the group proctor type ("G"), otherwise select the individual proctor type ("I").
			this.selectedType = this.groupview ? "G" : "I";

			// Update the proctor group list based on the selected proctor type.
			this.getProctorGroupList();
		},

		/**
		 * Sets the initial values of the `selectedType` and `groupview` data properties
		 * based on the value of the `redirect` query parameter in the given `route`.
		 *
		 * @param {Object} route - The route object containing the `redirect` query parameter.
		 * @returns {Object} An object containing the initial values of `selectedType` and `groupview`.
		 */
		setTabValuesFromRoute(route) {
			// Extract the `redirect` query parameter from the `route` object.
			const { redirect } = route.query;

			// Set the initial value of `selectedType` based on the `redirect` query parameter,
			// or default to "G" if the `redirect` parameter is not present.
			const selectedType = redirect || "G";

			// Set the initial value of `groupview` based on the value of `selectedType`
			const groupview = selectedType !== "I";

			// Return an object containing the initial values of `selectedType` and `groupview`.
			return { selectedType, groupview };
		},

		async getProctoringFilterData(type) {
			let payload = {
				topicID: this.storeTopicId,
				filterType: type,
				page: this.page,
				searchQuery: this.searchFilter,
			};
			if (payload.searchQuery == "") {
				delete payload.searchQuery;
			}
			if (payload.topicID == "") {
				delete payload.topicID;
			}
			const res = await getProcteringFilter(payload);
			if (res.status == 200) {
				this.showLoaderfilter = false;
				if (type === "TEST") {
					this.getProcteringFilterDataTest(res);
				} else {
					this.filterTopic =
						this.page === 0
							? res.data.data.data
							: [...this.filterTopic, ...res.data.data.data];
					this.filterTest = this.page === 0 ? [] : this.filterTest;
				}
				this.filterPageEnd = res.data.data.pageEnd;
				this.totalFilterData = res.data.data.total;
			}
		},

		getProcteringFilterDataTest(res) {
			this.filterTest =
				this.page === 0
					? res.data.data.data
					: [...this.filterTest, ...res.data.data.data];
			this.showtest = this.page === 0;
			this.filterTopic = this.page === 0 ? [] : this.filterTopic;
		},
	},
};
</script>

<style>
.graphFonts {
	width: 100%;
	font-weight: 400;
	font-size: 12px;
	line-height: 14px;
	/* identical to box height, or 140% */

	color: #696969;
}
.countDivData {
	display: flex;
	align-items: center;
}
.colorlineLine {
	height: 67px;
	width: 3px;
	background: #0acf97;

	margin-left: 0px;
	margin-right: 10px;
}

.countDivLine {
	background: rgba(252, 252, 252, 0.95);
}
.countDivOne {
	margin-right: 15px;
	background: rgba(252, 252, 252, 0.95);
}
.countDiv {
	display: flex;
	justify-content: space-between;
	padding: 10px;
	font-weight: 400;
	font-size: 10px;
	line-height: 14px;
	color: #696969;
	align-items: center;
}
.groupNameLine {
	display: flex;
	padding: 10px;
	font-weight: 600;
	font-size: 10px;
	line-height: 14px;
	color: #4eb6f0;
	background: #faf7f7;
}
.groupName {
	padding: 10px;
	font-weight: 600;
	font-size: 10px;
	line-height: 14px;
	color: #4eb6f0;
	background: #faf7f7;
}
.toolTip {
	position: absolute;
	display: none;
	width: auto;
	height: auto;

	color: black;
	font: 12px sans-serif;
	padding: 5px;
	text-align: center;
	background: #ffffff;
	border: 1px solid #f4f4f4;
	box-shadow: 0px 1px 10px #9f9f9f;
	border-radius: 5px;
}

.cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
	border-radius: 5px;
	z-index: 6;
	position: absolute;
	width: 355px;
	height: 320px;
	right: 0px;
	top: 40px;
}

.proct-paginaTion {
	position: absolute;
	width: 95%;
	padding: 5px 10px;
	left: 13px;
	bottom: 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}
.proct-gi-container {
	background: #ffffff;
	box-shadow: 0px 4px 13px rgb(196 196 196 / 50%);
	height: calc(100vh - 320px);
	overflow: auto;
}
.proct-gt-tctxt {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.proct-gt-tccounttxt {
	font-weight: 500;
	font-size: 14px;
	color: #84a3fe;
}

.proct-grpname {
	font-weight: 600;
	font-size: 14px;
	color: #1a4164;
}
.proctdash-gicards-gridcolorbar {
	width: 4px;
	background: #0acf97;
	border-radius: 2px;
	position: absolute;
	left: 5px;
	top: 2px;
	height: 90%;
}
.proctdash-gicards-Igridcolorbar {
	width: 4px;
	background: #00bad9;
	border-radius: 2px;
	position: absolute;
	left: 5px;
	top: 2px;
	height: 90%;
}

.proc-ctt-tabs-inactive {
	background: #ffffff;
	border: 1px solid #f0f0f0;
	box-shadow: 0px 4px 6px rgb(196 196 196 / 13%);
	border-radius: 0px 3px 3px 0px;
	padding: 10px;
	font-weight: 500;
	font-size: 12px;
	text-align: center;
	color: #696969;
	width: 105px;
}
.w-120 {
	width: 120px !important;
}
.reportbtn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 95px;
	text-align: center;
}
.proc-ctt-tabs-active {
	background: #f6f6fc;
	border: 1px solid #f0f0f0;
	box-shadow: 0px 4px 6px rgba(196, 196, 196, 0.13);
	border-radius: 3px 0px 0px 3px;
	padding: 10px;
	font-weight: 500;
	font-size: 12px;
	color: #3379b3;
	text-align: center;
	width: 105px;
}
.pr-sumry-subtxt {
	font-weight: 400;
	font-size: 11px;
	color: #696969;
}
.proct-tctg-count {
	font-weight: 600;
	font-size: 17px;
	color: #3379b3;
}
.proc-tctg {
	background: #f5f5f5;
	border-radius: 3px;
	padding: 10px;
}
.proctgtc-txt {
	font-weight: 400;
	font-size: 12px;
	color: #72738e;
}
.summary-txt {
	font-weight: 600;
	font-size: 14px;
	color: #030229;

	opacity: 0.7;
}
.pd-proct-parentdiv {
	height: calc(100vh - 70px);
	position: relative;
	width: 100%;
	top: 70px;
	background: #f3f3f3;
	padding-left: 85px;
	padding-right: 10px;
}

.proct-left-container {
	height: calc(100vh - 140px);
	width: 60%;
	overflow: auto;
}
.proct-right-container {
	height: calc(100vh - 140px);
	width: 39%;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
}
.proct-summary-card {
	background: #ffffff;
	border-radius: 10px;
	min-height: 57%;
	max-height: auto;
	padding: 14px;
}
.proct-evaluated-card {
	background: #ffffff;
	border-radius: 10px;
	min-height: 40%;
	max-height: auto;
	padding: 15px;
}
.chart-container {
	overflow-x: scroll;
	width: 100%;
	height: 73%;
	position: relative;
}
@media only screen and (max-height: 800px) {
	.chart-container {
		overflow-x: scroll;
		width: 100%;
		height: 65% !important;
		position: relative;
	}
}
.linechart-container {
	overflow-x: scroll;
	width: 100%;
	height: 87%;
	position: relative;
}
.pd-proct-parentdiv g .tick text {
	font-weight: 400;
	font-size: 10px;
	line-height: 12px;
	text-align: right;
	color: #a3a3a3;
}

.pd-proct-parentdiv g .tick line {
	color: #f0f0f0;
}
.pd-proct-parentdiv g path {
	color: #f0f0f0;
}

.barChart {
	overflow-x: auto;
	overflow-y: hidden;
}
.lineChart {
	overflow-x: auto;
	overflow-y: hidden;
}
.colorline {
	height: 20px;
	width: 3px;
	background: #0acf97;

	margin-left: 0px;
	margin-right: 10px;
}

.new-recsearchicon-pos {
	position: absolute;
	top: 7px;
	left: 6px;
}
.svg-container {
	width: 100%;
	vertical-align: top;
}

.svg-content-responsive {
	display: inline-block;
	position: relative;
	top: 10px;
	left: 0;
}
</style>
